import styled from 'styled-components'
import PropTypes from 'prop-types'

import theme from 'theme'
import { H1, H2, H3, H4, H5 } from 'lib/ui/primitives'

import Section from 'components/page/Section'
import Testimonial, { QuoteContainer } from 'components/Testimonial/Testimonial'
import GIFVideo from 'components/web/GIFVideo'
import { BACKGROUND_COLOR } from 'styles/GlobalStyle'
import Table from 'components/Table/SanityTable'

export const StyledH1 = styled(H1).attrs({ as: 'h2' })``
export const StyledH2 = styled(H2).attrs({ as: 'h3' })``
export const StyledH3 = styled(H3).attrs({ as: 'h4' })``
export const StyledH4 = styled(H4).attrs({ as: 'h5' })``
export const StyledH5 = styled(H5).attrs({ as: 'h6' })``

export const ContentGIFVideo = styled(GIFVideo)`
  max-width: 100%;
  display: block;
  margin: 0 auto;
  height: auto;
`

export const ContentTable = styled(Table)``

const TestimonialSection = styled(Section)`
  margin-top: 50px;
  padding: 0;
  width: 100vw;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  z-index: 100;
  position: relative;
  background: ${theme.colors.blacks[5]};

  ${QuoteContainer} {
    max-width: unset;
  }

  & img {
    box-shadow: none !important;
  }

  .testimonial-container {
    justify-content: center;
  }

  .testimonial-wrapper {
    width: 100vw;
    max-width: 100vw;
    margin: 0;
    background: ${BACKGROUND_COLOR};
    position: relative;
    left: 50%;
    transform: translateX(-50%);
  }
`

export const BlogTestimonial = ({ author, title, children }) => {
  return (
    <TestimonialSection id="testimonial" type="logo-bar">
      <Testimonial logo={null} author={author} title={title} inset>
        {children}
      </Testimonial>
    </TestimonialSection>
  )
}

BlogTestimonial.propTypes = {
  author: PropTypes.object,
  title: PropTypes.string,
  children: PropTypes.node,
}
